export default "../../../static/plugins/visualizations/nora/static/assets/fontawesome-webfont.f775f9cca88e21d45bebe185b27c0e5b.svg";